const themeColors = {
  darkBlue: '#05349A',
  navyMed: '#1C2F4E',
  white: '#FFFFFF',
  blue: '#1652F0',
  lightBlue: '#A5C1FD',
  lightestBlue: '#2460E1'
};
const blueTheme = {
  color: {
    background: themeColors.blue,
    border: themeColors.lightestBlue,
    text: themeColors.white,
    textAccent: themeColors.white,
    textLight: themeColors.white,
    backgroundAlt: themeColors.blue,
    textHover: themeColors.lightBlue,
    textAccentHover: themeColors.lightBlue,
    buttonFill: themeColors.white,
    buttonFillHover: 'rgba(255,255,255,0.8)',
    buttonText: themeColors.blue,
    secondaryButtonFill: themeColors.blue,
    secondaryButtonText: themeColors.white
  },
  logoKey: 'white'
};
export { blueTheme as default };
//# sourceMappingURL=blueTheme.js.map
